var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame30(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: 0.233597,
    y: 0.233597,
    width: 86.7413,
    height: 86.7412
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(4.38px)",
      clipPath: "url(#bgblur_0_1661_1025_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_1661_1025)",
    "data-figma-bg-blur-radius": 8.7664
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 69.2084,
    height: 69.2084,
    rx: 34.6042,
    fill: "#B08FFE",
    fillOpacity: 0.1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9875 32.6463V37.0295M39.2211 32.6463V37.0295",
    stroke: "#B08FFE",
    strokeWidth: 1.6437,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7001 34.8378H42.5085C38.3759 34.8378 36.3097 34.8378 35.0259 36.1216C33.7421 37.4055 33.7421 39.4717 33.7421 43.6042V45.7958C33.7421 49.9283 33.7421 51.9947 35.0259 53.2784C36.3097 54.5622 38.3759 54.5622 42.5085 54.5622H44.7001C48.8326 54.5622 50.8989 54.5622 52.1826 53.2784C53.4665 51.9947 53.4665 49.9283 53.4665 45.7958V43.6042C53.4665 39.4717 53.4665 37.4055 52.1826 36.1216C50.8989 34.8378 48.8326 34.8378 44.7001 34.8378Z",
    stroke: "#B08FFE",
    strokeWidth: 1.6437,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7421 41.4126H53.4665",
    stroke: "#B08FFE",
    strokeWidth: 1.6437,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5993 45.7959H43.6092M43.5993 50.1791H43.6092M47.9776 45.7959H47.9875M39.2211 45.7959H39.2309M39.2211 50.1791H39.2309",
    stroke: "#B08FFE",
    strokeWidth: 2.1916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_1661_1025",
    x: 0.233597,
    y: 0.233597,
    width: 86.7413,
    height: 86.7412,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 7.26121,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1661_1025"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.453826
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.690196 0 0 0 0 0.560784 0 0 0 0 0.996078 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1661_1025"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1661_1025",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.907652
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.71504
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.690196 0 0 0 0 0.560784 0 0 0 0 0.996078 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1661_1025"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_1661_1025_clip_path",
    transform: "translate(-0.233597 -0.233597)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 69.2084,
    height: 69.2084,
    rx: 34.6042
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame30);
export default __webpack_public_path__ + "static/media/Frame 30.551869658319ac048e0a38f80c79f4ba.svg";
export { ForwardRef as ReactComponent };